import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "../../Modal";
import useComponentWillMount from './../../helpers/useComponentWillMount'
import Spinner from "../../Spinner"

const useTimer = (targetDate) => {
  const [countDown, setCountDown] = useState(() => targetDate);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDown - 1);
    }, 1000);
    if (countDown <= 0) clearInterval(interval);

    return () => clearInterval(interval);
  }, [countDown]);

  return [String(countDown).padStart(2, '0'), () => { setCountDown(targetDate) }];
};

export default function ReserveConfirmPhone({ onConfirmPhone, errorMessage, backClickHandler }) {
  const { phrases } = window;
  const [counter, resetCounter] = useTimer(59);
  const [showError, setShowError] = useState(true)

  const { register, handleSubmit, formState: { isSubmitting, errors } } = useForm({ mode: 'all', defaultValues: { sms_code: '' }});
  const isCounterDone = !+counter;
  
  const onSubmit = async data => {
    try {
      await onConfirmPhone(data)
    } finally {
      setShowError(true)
    }
    return true
  };

  const repeatSendClickHandler = () => {
    if (isCounterDone) {
      onConfirmPhone()
      resetCounter();
    }
  }

  useComponentWillMount(() => {
    errors.sms_code = true
  }, [])

  return (
    <Modal
      title={phrases?.popup?.login?.common?.['confirm_title'] || "Confirm phone number"}
      cssModifyer="confirm-phone"
      modalView="xs"
    >
      <div className="form-cont">
        <form className="enter-tel-form" onSubmit={handleSubmit(onSubmit)}>
          <label className="form-label " htmlFor="confirm-phone-sms">
            <input
              id="confirm-phone-sms"
              type="text"
              // name="sms_code"
              className="form-label__input"
              autoComplete="off"
              onChange={() => showError && setShowError(false)}
              // defaultValue=""
              autoFocus
              {...register("sms_code", { pattern: /^[0-9]{6}$/, minLength: 6, maxLength: 6, required: true })} />
            <span className="form-label__placeholder">{phrases?.popup?.login?.fields?.code || "Code from SMS"}</span>
            {errorMessage && showError ?
              <span className="error-text" style={{ display: 'block' }}>{errorMessage}</span>
              :
              <span className="notice-text">{phrases?.popup?.login?.common?.['consist_of'] || "Consists of 6 digits"}</span>
            }
          </label>
          <button
            type="submit"
            disabled={isSubmitting || errors.sms_code}
            className="wb-btn btn-yellow js_modal_confirm_phone_send">
            {isSubmitting ? <Spinner /> : phrases?.popup?.login?.common?.['confirm_submit'] || "confirm_submit"}
          </button>
          <div className="row-time">
            <div className={`row-time-item ${isCounterDone ? 'green' : ''}`} onClick={repeatSendClickHandler}>
              {phrases?.popup?.login?.common?.resubmit || "Resubmit"}&nbsp;<div className="timer" style={{ display: isCounterDone ? 'none' : 'inline-block' }}> (00:{counter})</div>
            </div>
          </div>
        </form>
        <button className="back-btn" onClick={backClickHandler}>
          {phrases?.popup?.login?.common?.back || "Back"}
        </button>
      </div>
    </Modal>
  );
}
